import { IDay } from '@df/catalog/store/store';
import { isSameDay } from '@df/util/fn/is-same-day';
import find from 'lodash-es/find';

export function getTodayOpeningHours(openingHours: IDay[]): IDay | undefined {
    const today = new Date();
    return openingHours.find(day => day && day.date && isSameDay(day.date, today));
}
